import React from "react";

// Gift/Discount Icon
export const GiftIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="10" width="24" height="18" rx="2" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" />
    <path d="M4 14H28" stroke="#6A4F0A" strokeWidth="1.5" />
    <rect x="13" y="4" width="6" height="10" rx="1" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" />
    <path d="M16 4V14" stroke="#6A4F0A" strokeWidth="1.5" />
    <path d="M10 6C10 6 7 8 7 11" stroke="#6A4F0A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M22 6C22 6 25 8 25 11" stroke="#6A4F0A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
  </svg>
);

// Clock/Timer Icon
export const ClockIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="12" stroke="#FCBB18" strokeWidth="1.5" fill="none" />
    <path d="M16 8V16L22 20" stroke="#FCBB18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="16" cy="16" r="2" fill="#FCBB18" />
  </svg>
);

// Star/Sparkle Icon
export const StarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 2L19.82 12.18H30.36L21.73 18.54L25.55 28.82L16 22.46L6.45 28.82L10.27 18.54L1.64 12.18H12.18L16 2Z" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

// Bell/Notification Icon
export const BellIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 12C24 8.13 21.31 5 18 5C16 5 14.2 6 13.3 7.5C12.88 7.18 12.48 7 12 7C10.34 7 9 8.34 9 10C9 10.34 9.06 10.68 9.16 11C6.32 11.96 4 14.73 4 18C4 20.5 5.2 22.7 7 24M24 12C24 15.27 21.68 17.96 18.84 18.97C18.94 18.32 19 17.66 19 17C19 13.13 16.31 10 13 10M24 12H29M7 24H25M8 27H24C24.55 27 25 27.45 25 28V29H7V28C7 27.45 7.45 27 8 27Z" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="0.5" />
  </svg>
);

// Rocket/Launch Icon
export const RocketIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 2C16 2 10 8 10 14C10 17.31 12.69 20 16 20C19.31 20 22 17.31 22 14C22 8 16 2 16 2Z" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" />
    <circle cx="16" cy="11" r="2" fill="#6A4F0A" />
    <path d="M10 20L12 28H8L5 24" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M22 20L20 28H24L27 24" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M14 20L16 26L18 20" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

// Diamond/Jewelry Icon
export const DiamondIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 2L24 10L20 25H12L8 10L16 2Z" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16 2L24 10" stroke="#6A4F0A" strokeWidth="1.5" />
    <path d="M16 2L8 10" stroke="#6A4F0A" strokeWidth="1.5" />
    <circle cx="16" cy="15" r="2" fill="#6A4F0A" />
  </svg>
);

// Heart/Love Icon
export const HeartIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 28C16 28 3 20 3 12C3 7.58 6.58 4 10 4C12 4 14 5 16 7C18 5 20 4 22 4C25.42 4 29 7.58 29 12C29 20 16 28 16 28Z" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

// CheckMark Icon
export const CheckMarkIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="14" fill="#FCBB18" stroke="#6A4F0A" strokeWidth="1.5" />
    <path d="M10 16L14 20L22 10" stroke="#6A4F0A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
